<template>
    <v-flex xs12 sm12 md8>

        <v-card style="background-color: transparent !important" width="100%">
            <v-card flat class="text-xs-center ma-3">
                <v-card-title class=" primary">
                    <span class="card-title-text" style="color: white; font-size:small">
                        <v-icon size="14" color="white">
                            mdi-account-group
                        </v-icon> TERCEROS
                    </span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>

                    <v-row>
                        <v-col md="12">

                            <v-row v-if="updateTable">
                                <v-col md="12">

                                    <DataTable :url="urlListado" :columns="columns" :params="displayInputs"
                                        :order="[[0, 'desc']]" :formatterActions="formatterActions"
                                        @apiDT="datos.apiDT = $event" select="single" @input="detalleTercero"
                                        :reduce="fila => fila.d3id" :includeDataRow="false" :value="datos.clave">
                                    </DataTable>



                                </v-col>
                            </v-row>

                        </v-col>
                    </v-row>
                    <v-col md="12" v-if="!disabledbutton">
                        <v-row class="mb-4">

                            <v-btn class="ma-2" @click="nuevoAgregarTercero()" color="green" :disabled="disabledbutton">
                                <span style='color: white;'>Agregar</span>
                            </v-btn>
                            <v-btn v-if="permisoEliminar == 1 && valEli" class="ma-2" @click="eliminarTercero()"
                                color="#FF4081" :disabled="disabledbutton">
                                <span style='color: white;'>Eliminar</span>
                            </v-btn>
                        </v-row>
                    </v-col>
                    <v-form ref="form" v-model="validForm" lazy-validation>
                        <v-card-text>
                            <v-col md="12">
                                <v-row>
                                    <v-col cols="6" sm="4" md="4">
                                        <v-checkbox v-model="datos.d3danios" :class="classdisabled" label="Daños"
                                            style="margin: 0px" @change="validation.errorDelito = false"
                                            hide-details></v-checkbox>
                                    </v-col>
                                    <v-col cols="6" sm="4" md="4">
                                        <v-checkbox v-model="datos.d3lesiones" :class="classdisabled" label="Lesiones"
                                            style="margin: 0px"
                                            @change="datos.d3lesionesclave = null, validation.errorDelito = false"
                                            hide-details></v-checkbox>
                                        <v-radio-group v-model="datos.d3lesionesclave"
                                            @change="validation.errorLesiones = false" :class="classdisabled"
                                            v-if="datos.d3lesiones" style="margin: -1px; margin-left: 13px;">
                                            <v-radio label="Ambulatorias" value="1"></v-radio>
                                            <v-radio label="Hospitalización" value="2"></v-radio>
                                        </v-radio-group>
                                        <!--validacion-->
                                        <div v-if="validation.errorLesiones">
                                            <span class='spanError' style="color:red;font-size:13px">
                                                Indique una
                                                opción
                                            </span>
                                            <br />
                                        </div>
                                    </v-col>
                                    <v-col cols="6" sm="4" md="4">
                                        <v-checkbox v-model="datos.d3homicidio" :class="classdisabled"
                                            label="Homicidios" style="margin: 0px"
                                            @change="validation.errorDelito = false" hide-details></v-checkbox>
                                    </v-col>

                                </v-row>
                                <!--validacion-->
                                <div v-if="validation.errorDelito">
                                    <span class='spanError' style="color:red;font-size:12px">
                                        Favor de seleccionar daños,
                                        lesiones u homicidio
                                    </span>
                                    <br />
                                </div>
                                <!--validacion-->
                                <div v-if="validation.errorDelitoLH">
                                    <span class='spanError' style="color:red;font-size:12px">
                                        No puede seleccionar lesiones y
                                        homicidio
                                    </span>
                                    <br />
                                </div>
                                <!--validacion-->
                                <div v-if="validation.errorDaniosOcupante">
                                    <span class='spanError' style="color:red;font-size:12px">
                                        No puede seleccionar daños y
                                        ocupante simultáneamente
                                    </span>
                                    <br />
                                </div>
                                <!--validacion-->
                                <div v-if="validation.errorHomicidioFuga">
                                    <span class='spanError' style="color:red;font-size:12px">
                                        No puede seleccionar Homicidio
                                        y Fuga simultáneamente
                                    </span>
                                    <br />
                                </div>
                            </v-col>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-col md="12">
                                <h4 class="text-info" style="color: #2196f3; font-size: 18px; ">Tipo</h4>

                                <v-row>
                                    <v-col md="12">
                                        <v-radio-group v-model="datos.d3tipo" :class="classdisabled"
                                            @change="validation.errorTipoT = false">
                                            <v-row>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-radio label="Conductor" value="T"></v-radio>
                                                    <v-radio label="Peatón" value="P"></v-radio>

                                                </v-col>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-radio label="Ocupante" value="O"></v-radio>
                                                    <v-radio label="Inmueble / Otro" value="I"></v-radio>

                                                </v-col>
                                            </v-row>
                                        </v-radio-group>
                                    </v-col>

                                </v-row>
                                <!--validacion-->
                                <div v-if="validation.errorTipoT">
                                    <span class='spanError' style="color:red;font-size:12px">
                                        Seleccione el tipo de
                                        tercero
                                    </span>
                                    <br />
                                </div>


                            </v-col>

                        </v-card-text>

                        <v-divider></v-divider>
                        <v-card-text>
                            <v-col md="12">
                                <h4 class="text-info" style="color: #2196f3; font-size: 18px; ">El conductor está</h4>
                                <v-row>
                                    <v-col md="12">
                                        <v-radio-group v-model="datos.d3situacion" :class="classdisabled"
                                            @change="validation.errorEstadoT = false">
                                            <v-row>
                                                <v-col cols="12" sm="4" md="4">
                                                    <v-radio label="Presente" value="P"></v-radio>

                                                </v-col>
                                                <v-col cols="12" sm="4" md="4">
                                                    <v-radio label="Ubicado" value="U"></v-radio>

                                                </v-col>
                                                <v-col cols="12" sm="4" md="4">
                                                    <v-radio label="Fuga" value="F"></v-radio>

                                                </v-col>
                                            </v-row>
                                        </v-radio-group>
                                    </v-col>

                                </v-row>

                                <!--validacion-->
                                <div v-if="validation.errorEstadoT">
                                    <span class='spanError' style="color:red;font-size:12px">
                                        Seleccione el estado del
                                        tercero
                                    </span>
                                    <br />
                                </div>


                            </v-col>
                            <v-col md="12">
                                <h4 class="text-info" style="color: #2196f3; font-size: 18px; ">Agravantes</h4>

                                <v-row>
                                    <v-col>
                                        <v-checkbox v-model="datos.d3ebriedad" :class="classdisabled"
                                            label="Estado de ebriedad" style="margin: 0px" hide-details></v-checkbox>
                                        <v-checkbox v-model="datos.d3drogas" :class="classdisabled"
                                            label="Drogas o estupefacientes" style="margin: 0px"
                                            hide-details></v-checkbox>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <span style="font-weight: bold;">Nombre :</span>
                                        <v-text-field v-model="datos.d3nombre" v-on:blur="
                                datos.d3nombre = datos.d3nombre != null ? datos.d3nombre.trim() : null" outlined dense
                                                      :rules="rulesInputs(14, 50)" :disabled="edit" :filled="edit"
                                                      :error-messages="validation.errorNombre"></v-text-field>
                                        <span style="font-weight: bold;">Domicilio :</span>
                                        <v-text-field v-model="datos.dedirec" v-on:blur="
                                datos.dedirec = datos.dedirec != null ? datos.dedirec.trim() : null" outlined dense
                                                      :rules="rulesInputs(14, 60)" :disabled="edit" :filled="edit"
                                                      :error-messages="validation.errorDomicilio"></v-text-field>

                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <span style="font-weight: bold;">Correo Eléctronico :</span>
                                        <v-text-field v-model="datos.d3email" outlined dense
                                                      :rules="rulesInputsEmail(datos.d3email)" :disabled="edit"
                                                      :filled="edit"></v-text-field>
                                        <span style="font-weight: bold;">Teléfonos:</span>



                                        <vs-list v-for="(telefono, index) in telefonos" :key="index">
                                            <v-list-item-content>
                                                <span style=" font-size: 14px;">
                                                    {{ telefono.stadescripcion }}
                                                </span>
                                                <v-list-item-subtitle>

                                                    <vs-col v-if="telefono.banderaview == 'true'" vs-lg="8"
                                                            style="margin-top: 5px;">
                                                        <v-icon :title="telefono.title" color="indigo">
                                                            {{
                                telefono.icon
                                                            }}
                                                        </v-icon>
                                                        <span v-if="permisoIVR && !valAlta" class="hoverTel"
                                                              style=" font-size: 15.5px; text-align: center;"
                                                              v-on:click="LlamadaIVR(telefono)">
                                                            {{ telefono.prefijo }}
                                                            {{
 separarNumeroTelefono(telefono.stnumero.substring(0, 10))
                                                            }}
                                                        </span>
                                                        <span v-else style=" font-size: 15.5px; text-align: center;">
                                                            {{ telefono.prefijo }}
                                                            {{
 separarNumeroTelefono(telefono.stnumero.substring(0, 10))
                                                            }}
                                                        </span>


                                                    </vs-col>
                                                    <vs-col v-else vs-lg="8" style="margin-top: 5px;">
                                                        <v-icon :title="telefono.title" color="indigo">
                                                            {{
                                telefono.icon
                                                            }}
                                                        </v-icon>
                                                        <span v-if="permisoIVR && !valAlta" class="hoverTel"
                                                              style=" font-size: 15.5px; text-align: center;"
                                                              v-on:click="LlamadaIVR(telefono)">
                                                            {{ telefono.prefijo }}
                                                            {{
                                ocultartele(separarNumeroTelefono(telefono.stnumero.substring(0,
                                    6)))
                                                            }}
                                                            {{
 separarNumeroTelefono(telefono.stnumero.substring(6, 10))
                                                            }}
                                                        </span>
                                                        <span v-else style=" font-size: 15.5px; text-align: center;">
                                                            {{ telefono.prefijo }}
                                                            {{
                                ocultartele(separarNumeroTelefono(telefono.stnumero.substring(0,
                                    6)))
                                                            }}
                                                            {{
 separarNumeroTelefono(telefono.stnumero.substring(6, 10))
                                                            }}
                                                        </span>


                                                    </vs-col>


                                                    <vs-col class="ml-2" vs-lg="1"
                                                            v-if="activeTelefonosdet && vguardaedita && !agregarEditTelefonos && !vagregarTelefonos">

                                                        <v-btn icon title="Eliminar"
                                                               @click="eliminaTelf(telefono, index)" color="red">
                                                            <v-icon small>mdi-delete</v-icon>
                                                        </v-btn>
                                                        <!--<v-btn icon id="veri"
                               @click="VerModal(telefono, index, '')" title="Ver teléfono1"
                               color="primary"><v-icon>mdi-eye</v-icon></v-btn>-->
                                                    </vs-col>
                                                    <vs-col class="ml-2" vs-lg="1"
                                                            v-if="vagregarTelefonos && !agregarEditTelefonos">

                                                        <v-btn icon title="Eliminar"
                                                               @click="eliminaTelfAlta(telefono, index)" color="red">
                                                            <v-icon small>mdi-delete</v-icon>
                                                        </v-btn>
                                                        <!--<v-btn icon id="veri"
                               @click="VerModal(telefono, index, '')" title="Ver teléfono2"
                               color="primary"><v-icon>mdi-eye</v-icon></v-btn>-->
                                                    </vs-col>

                                                    <vs-col class="ml-2" vs-lg="1" v-if="permisoOfuscar">

                                                        <v-btn v-if="telefono.banderaview == 'false'" icon id="veri"
                                                               @click="VerModal(telefono, index, '')" title="Ver teléfono"
                                                               color="primary"><v-icon>mdi-eye</v-icon></v-btn>
                                                        <v-btn v-else icon @click="OcultaTel(telefono, index, '')"
                                                               title="Ocultar Teléfono"
                                                               color="primary"><v-icon>mdi-eye-off</v-icon></v-btn>
                                                    </vs-col>

                                                </v-list-item-subtitle>

                                            </v-list-item-content>

                                        </vs-list>
                                        <div v-if="activeTelefonosdet">
                                            <div v-if="agregarEditTelefonos">
                                                <v-form ref="formTelf" v-model="validTelf" lazy-validation>
                                                    <span style="font-weight: bold;">Tipo:</span>
                                                    <multiselect v-model="datos.sttid"
                                                                 deselect-label="No se puede remover el valor seleccionado"
                                                                 selected-label="Seleccionado" track-by="sttid"
                                                                 label="sttdescripcion" placeholder="Seleccione una opción"
                                                                 :options="opcionestipotelf" :allow-empty="false">
                                                    </multiselect>
                                                    <div v-if="validaTipo">
                                                        <span class='spanError' style="color:red;font-size:12px">
                                                            Campo
                                                            requerido
                                                        </span>
                                                        <br />
                                                    </div>
                                                    <span style="font-weight: bold;">Número:</span>
                                                    <vue-tel-input-vuetify v-model="datos.numtelf"
                                                                           :error-messages="errorTelf" @input="onInput" outlined label=""
                                                                           autocomplete="off" loading="true" max="10" required
                                                                           placeholder="" :defaultCountry="pais"
                                                                           validCharactersOnly="false"
                                                                           v-on:country-changed="countryChanged"
                                                                           dense></vue-tel-input-vuetify>
                                                </v-form>

                                            </div>

                                            <div v-if="!agregarEditTelefonos">
                                                <br />
                                                <v-btn small color="primary" title="Agregar" @click="agregarTelefono()">
                                                    <v-icon>mdi-plus</v-icon>
                                                </v-btn>
                                            </div>
                                            <div v-if="agregarEditTelefonos">
                                                <v-col md="12">
                                                    <v-row justify="center">
                                                        <v-btn small class="ma-2" color="#FF4081" title="Cancelar"
                                                               @click="cancelarTelefono()" :disabled="disabledsaveTelf">
                                                            <v-icon color="white">mdi-close</v-icon>
                                                        </v-btn>
                                                        <v-btn v-if="vguardaedita && !vagregarTelefonos" small
                                                               class="ma-2" color="primary" title="Guardar"
                                                               @click="guardarTelefono()" :disabled="disabledsaveTelf">
                                                            <v-icon>mdi-content-save</v-icon>
                                                        </v-btn>

                                                        <v-btn v-if="!vguardaedita && !vagregarTelefonos" small
                                                               class="ma-2" color="primary" title="Editar"
                                                               @click="editaTelefonoGuardar()"
                                                               :disabled="disabledsaveTelf">
                                                            <v-icon>mdi-content-save</v-icon>
                                                        </v-btn>
                                                        <v-btn v-if="vagregarTelefonos" small class="ma-2"
                                                               color="primary" title="Guardar"
                                                               @click="altaTelefonoGuardar()" :disabled="disabledsaveTelf">
                                                            <v-icon>mdi-content-save</v-icon>
                                                        </v-btn>
                                                    </v-row>
                                                </v-col>

                                            </div>
                                        </div>



                                    </v-col>

                                    <v-col v-if="showVh">
                                        <h4 class="text-info" style="color: #2196f3; font-size: 18px; ">Tipo de persona</h4>
                                        <v-radio-group v-model="datos.d3tpersona" :class="classdisabled"
                                                       :rules="rulesO" inline style="margin: 0px">
                                            <v-radio label="Física" value="0"></v-radio>
                                            <v-radio label="Moral" value="1"></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                </v-row>


                            </v-col>
                        </v-card-text>


                        <v-divider></v-divider>
                        <v-card-text>
                            <v-col md="12">
                                <h4 class="text-info" style="color: #2196f3; font-size: 18px; ">Daños</h4>

                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <span style="font-weight: bold;">Marca :</span>
                                        <multiselect v-model="datos.mrclave" deselect-label="Quitar opción"
                                            :disabled="edit" selected-label="Seleccionado"
                                            select-label="Seleccione Marca" track-by="mrclave" label="mrnombre"
                                            placeholder="Seleccione una opción" :options="opcionesMarca"
                                            :allow-empty="true">
                                        </multiselect>
                                        <!--validacion-->
                                        <div v-if="validation.errorMarca">
                                            <span class='spanError' style="color:red;font-size:12px">
                                                Seleccione una
                                                opción
                                            </span>
                                            <br />
                                        </div>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <span style="font-weight: bold;">Modelo :</span>
                                        <multiselect v-model="datos.mdclave" deselect-label="Quitar opción"
                                            :disabled="edit" selected-label="Seleccionado"
                                            select-label="Seleccione Modelo" track-by="mdclave" label="mdnombre"
                                            placeholder="Seleccione una opción" :options="opcionesModelos"
                                            :allow-empty="true">
                                        </multiselect>
                                        <!--validacion-->
                                        <div v-if="validation.errorModelo">
                                            <span class='spanError' style="color:red;font-size:12px">
                                                Seleccione una
                                                opción
                                            </span>
                                            <br />
                                        </div>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <span style="font-weight: bold;">Año :</span>
                                        <v-text-field v-model="datos.d3anio" v-on:blur="limpiarCheckanio()" outlined
                                            dense :rules="rulesInputsAnio" @keypress="ruleNumbers($event, datos.d3anio)"
                                            :disabled="edit" :filled="edit"
                                            :error-messages="validation.errorAnio"></v-text-field>
                                        <v-checkbox v-model="datos.d3sindatoanio"
                                            style="margin: -15px; margin-left: 4px;" :class="classdisableanio"
                                            @change="limpiaranio()" label="Sin dato del año"></v-checkbox>
                                        <span style="font-weight: bold;">Color :</span>
                                        <v-text-field v-model="datos.d3color"
                                            v-on:blur="datos.d3color = datos.d3color != null ? datos.d3color.trim() : null"
                                            outlined dense :rules="rulesInputs(3, 15)" :disabled="edit" :filled="edit"
                                            :error-messages="validation.errorColor"></v-text-field>
                                        <div v-if="showmontooficial">
                                            <span style="font-weight: bold;">Monto Autoridad: </span>
                                            <span>${{ datos.d3montooficial }}</span>
                                        </div>
                                        <br />
                                        <div v-if="!showmontooficial">
                                            <br />
                                        </div>
                                        <span style="font-weight: bold;">Compañía :</span>
                                        <multiselect v-model="datos.aseclave"
                                            deselect-label="No se puede remover el valor seleccionado" :disabled="edit"
                                            selected-label="Seleccionado" select-label="Seleccione compañia"
                                            track-by="aseclave" label="asenombre" placeholder="Seleccione una opción"
                                            :options="opcionesAseguradoras" :allow-empty="false">
                                        </multiselect>
                                        <!--validacion-->
                                        <div v-if="validation.errorCompania">
                                            <span class='spanError' style="color:red;font-size:12px">
                                                Seleccione una
                                                opción
                                            </span>
                                        </div>

                                    </v-col>

                                    <v-col cols="12" sm="6" md="6">
                                        <span style="font-weight: bold;">Placas :</span>
                                        <v-text-field v-model="datos.d3placa"
                                            v-on:blur="datos.d3placa = datos.d3placa != null ? datos.d3placa.trim() : null"
                                            outlined dense :rules="rulesInputs(5, 50)" :disabled="edit" :filled="edit"
                                            :error-messages="validation.errorPlaca"></v-text-field>
                                        <span style="font-weight: bold;">Estimado de daños :</span>
                                        <v-text-field v-model="datos.d3montoest" outlined dense
                                            :rules="rulesInputsNumber" @blur="limpiarCheckDanios()"
                                            @keypress="ruleMoney($event, datos.d3montoest)" :disabled="valestdanios"
                                            :filled="valestdanios"
                                            :error-messages="validation.errorEstimadoDanios"></v-text-field>
                                        <v-checkbox v-model="datos.montopendientedanios" :class="classdisableddanios"
                                            label="Monto pendiente" style="margin: -14px; margin-left: 4px;"
                                            @change="limpiarDanios()" hide-details></v-checkbox>
                                        <br />
                                        <br />
                                        <span style="font-weight: bold;">Estimado de Lesiones :</span>
                                        <v-text-field v-model="datos.d3montoestles" outlined dense
                                            :rules="rulesInputsNumber" @blur="limpiarCheckLesiones()"
                                            @keypress="ruleMoney($event, datos.d3montoestles)"
                                            :disabled="valestlesiones" :filled="valestlesiones"
                                            :error-messages="validation.errorEstimadoLesiones"></v-text-field>
                                        <v-checkbox v-model="datos.montopendientelesiones"
                                            :class="classdisabledlesiones" label="Monto pendiente"
                                            style="margin: -15px; margin-left: 4px;" @change="limpiarLesiones()"
                                            hide-details></v-checkbox>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">

                                        <span style="font-weight: bold;">Tipo de Cobertura :</span>
                                        <multiselect v-model="datos.d3tipocob" deselect-label="Quitar opción"
                                            :disabled="valaseguradora" selected-label="Seleccionado"
                                            select-label="Seleccione coberturaa" track-by="d3tipocob" label="text"
                                            placeholder="Seleccione una opción" :options="opcionesCobertura"
                                            :allow-empty="true">
                                        </multiselect>
                                        <!--validacion-->
                                        <div v-if="validation.errorCobertura">
                                            <span class='spanError' style="color:red;font-size:12px">
                                                Seleccione una
                                                opción
                                            </span>
                                        </div>
                                        <br />
                                        <div v-if="showVh">
                                            <span style="font-weight: bold;">Vehículo Detenido :</span>
                                            <v-radio-group row v-model="datos.d3vehdet" :class="classdisabled"
                                                :rules="rulesO" inline style="margin: -1px; margin-left: 15px;">
                                                <v-radio label="Sí" value="1"></v-radio>
                                                <v-radio label="No" value="0"></v-radio>
                                            </v-radio-group>
                                        </div>

                                        <span style="font-weight: bold;">No.Póliza :</span>
                                        <v-text-field v-model="datos.d3poliza"
                                            v-on:blur="datos.d3poliza = datos.d3poliza != null ? datos.d3poliza.trim() : null"
                                            outlined dense :rules="rulesInputs(8, 60)" :disabled="valaseguradora"
                                            :filled="valaseguradora"
                                            :error-messages="validation.errorPoliza"></v-text-field>
                                    </v-col>





                                    <v-col cols="12" sm="6" md="6">


                                        <span style="font-weight: bold;">Monto Libro Azul:</span>
                                        <v-text-field v-model="datos.d3montoazul" outlined dense
                                            :rules="rulesInputsNumber" @keypress="ruleMoney($event, datos.d3montoazul)"
                                            :error-messages="validation.montoazul" :disabled="edit"
                                            :filled="edit"></v-text-field>
                                        <div v-if="showVh">
                                            <span style="font-weight: bold;">Acreditación de VH :</span>
                                            <div class="wrapper" style="margin-top: -18px;">
                                                <label style="margin-right: 5px; margin-top: 2px;">No</label>
                                                <input type="range" name="points" @change="filterme($event)" min="1"
                                                    step="1" id="custom-toggle" class="tgl-def" max="3" :value="check"
                                                    :disabled="edit" :filled="edit">
                                                <label style="margin-left: 5px; margin-top: 2px;">Sí</label>
                                            </div>
                                        </div>

                                        <span style="font-weight: bold;">No.Siniestro :</span>
                                        <v-text-field v-model="datos.d3siniestro"
                                            v-on:blur="datos.d3siniestro = datos.d3siniestro != null ? datos.d3siniestro.trim() : null"
                                            outlined dense :rules="rulesInputs(8, 60)" :disabled="valaseguradora"
                                            :filled="valaseguradora"
                                            :error-messages="validation.errorSiniestro"></v-text-field>
                                    </v-col>


                                    <v-col cols="12" sm="12" md="12">
                                        <span style="font-weight: bold;">Observaciones</span>
                                        <v-textarea @input="uppercase('d3descdanos')"
                                            v-on:blur="datos.d3descdanos = datos.d3descdanos != null ? datos.d3descdanos.trim() : null"
                                            :counter="$store.state.maxLengthComentarios" :rules="rulestextarea" outlined
                                            rows="2" :disabled="edit" :maxlength="$store.state.maxLengthComentarios"
                                            :filled="edit" v-model="datos.d3descdanos"></v-textarea>


                                    </v-col>

                                    <v-col md="12" v-if="valAlta || valEdit">
                                        <v-row justify="center">

                                            <v-btn v-if="valAlta" class="ma-2" color="primary" title="Guardar"
                                                @click="guardarNuevoTercero()" :disabled="disabledSave">
                                                <span style='color: white;'>Guardar</span>
                                            </v-btn>

                                            <v-btn v-if="valEdit" class="ma-2" color="primary"
                                                @click="guardarEdicionTercero()" :disabled="disabledSave">
                                                <span style='color: white;'>Guardar</span>
                                            </v-btn>

                                            <v-btn class="ma-2" @click="cancelar()" color="#FF4081"
                                                :disabled="disabledSave">
                                                <span style='color: white;'>Cancelar</span>
                                            </v-btn>
                                        </v-row>
                                    </v-col>

                                    <v-col md="12" v-if="!valAlta && !valEdit && d3id != 0 && validatermino">
                                        <v-row>
                                            <v-btn v-if="valdanos && !validaConclusion" class="ma-2" color="green"
                                                title="Concluir Daños" @click="irConcluirDanos()">
                                                <span style='color: white;'>Concluir Daños</span>
                                            </v-btn>
                                            <v-btn v-if="valdanosVer" class="ma-2" color="green"
                                                title="Ver Conclusión Daños" @click="verConcluirDanos()">
                                                <span style='color: white;'>Ver Conclusión Daños</span>
                                            </v-btn>
                                            <v-btn v-if="valleshom && !validaConclusion" class="ma-2" color="green"
                                                title="Concluir Lesiones" @click="irConcluirLesiones()">
                                                <span style='color: white;'>Concluir Lesiones</span>
                                            </v-btn>
                                            <v-btn v-if="valleshomVer" class="ma-2" color="green"
                                                title="Ver Conclusión Lesiones" @click="verConcluirLesiones()">
                                                <span style='color: white;'>Ver Conclusión Lesiones</span>
                                            </v-btn>
                                            <v-btn class="ma-2" color="green" title="Negociaciones"
                                                @click="irNegociaciones()">
                                                <span style='color: white;'>Negociaciones</span>
                                            </v-btn>

                                        </v-row>
                                    </v-col>



                                </v-row>





                            </v-col>
                        </v-card-text>



                    </v-form>

                </v-card-text>
            </v-card>
        </v-card>

        <div>
            <v-dialog transition="dialog-top-transition" persistent max-width="600" v-model="modal">
                <v-card>
                    <v-toolbar color="primary" dark>Firma Electrónica</v-toolbar>
                    <v-card-text>
                        <label style="font-style: italic; color:darkred">
                            Para ver los números de teléfono es necesario
                            ingresar su firma electrónica
                        </label>
                        <br />
                        <label> Firma electrónica: </label>
                        <br />
                        <v-text-field id="firma" ref="input" v-model="firma" autocomplete="off" maxlength="17"
                            style="-webkit-text-security: disc;" @focus="Foco()" autofocus solo></v-text-field>
                        <span v-if="msg" id="revfirmaelectronica" style="font-style: italic; color: red">{{ texto
                            }}</span>

                        <br />
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-btn @click="CerrarModal()">Cerrar</v-btn>
                        <v-btn @click="ValidarFirma()" color="primary" :loading="loading"
                            :disabled="loading">Aceptar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </v-flex>
</template>


<script>
import Reporte from "@/services/ExpJur/ExpJur.service.js";
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import DataTable from "@/components/pages/DataTableNet/DataTable";
import Contacto from '@/services/DatosDeContacto/DatosContacto.service.js';

import { mapState } from 'vuex';

export default {
    components: {
        DataTable
    },
    props: {
        validatermino: false,
        validaConclusion: false,
        svresponsabled: false
    },
    data() {
        return {
            check: 2,
            showVh: false,
            //Datos para IVR
            permisoIVR: false,
            ivr: null,
            LLamarSintiempo: false,

            valEli: false,
            validForm: true,
            disabledSave: false,
            datos: {
                d3danios: false,
                d3lesiones: false,
                d3lesionesclave: null,
                d3homicidio: false,
                d3tipo: null,
                d3situacion: null,
                d3ebriedad: false,
                d3drogas: false,
                d3nombre: null,
                dedirec: null,
                d3email: null,
                mrclave: null,
                mdclave: null,
                d3anio: null,
                d3color: null,
                d3placa: null,
                d3montoest: null,
                montopendientedanios: false,
                aseclave: null,
                d3tipocob: null,
                d3vehdet: null,
                d3acreditaVh: null,
                d3poliza: null,
                d3montoestles: null,
                montopendientelesiones: false,
                d3montoazul: null,
                d3siniestro: null,
                d3descdanos: null,
                d3tpersona: null,

                sttid: null,
                numtelf: null,

                clave: null,
                apiDT: null,

                valmontopendientedanios: false,
                valmontopendienteleshom: false,
                d3montooficial: null,
                d3sindatoanio: false,
            },
            telefonos: [],
            opcionesMarca: [],
            opcionesModelos: [],
            opcionesAseguradoras: [],
            opcionesCobertura: [
                {
                    d3tipocob: "A",
                    text: "Amplia"
                },
                {
                    d3tipocob: "L",
                    text: "Limitada"
                }
            ],
            opcionestipotelf: [],
            errorTelf: [],

            valestdanios: true,
            valestlesiones: true,
            classdisableddanios: "disable-action",
            classdisabledlesiones: "disable-action",
            classdisableanio: "disable-action",
            permisoEliminar: 0,

            valAlta: false,
            valEdit: false,
            valaseguradora: true,

            activeTelefonosdet: false,
            agregarEditTelefonos: false,
            phone: {
                number: null,
                valid: false,
                country: null
            },
            prefijo: null,
            pais: 'MX',
            validTelf: true,
            validaTipo: false,
            disabledsaveTelf: false,
            vguardaedita: true,
            datosTelefono: null,
            vagregarTelefonos: false,

            validation: {
                errorDelito: false,
                errorDelitoLH: false,
                errorDaniosOcupante: false,
                errorHomicidioFuga: false,
                errorLesiones: false,
                errorTipoT: false,
                errorEstadoT: false,
                errorCompania: false,
                errorCobertura: false,
                errorMarca: false,
                errorModelo: false,

                errorNombre: '',
                errorDomicilio: '',
                errorAnio: '',
                errorPlaca: '',
                errorColor: '',
                errorEstimadoDanios: '',
                errorEstimadoLesiones: '',
                errorPoliza: '',
                errorSiniestro: '',
                montoazul: '',

            },
            valdanos: false,
            valdanosVer: false,
            valleshom: false,
            valleshomVer: false,
            d3id: 0,
            urlListado: "ExpJur/ListadoTerceros",
            columns: [
                { name: 'Situacion', data: 'Situacion', title: "Situación" },
                { name: 'Nombre', data: 'Nombre', title: "Tercero" },
                { name: 'Danios', data: 'Danios', title: "Daños" },
                { name: 'Lesiones', data: 'Lesiones', title: "Lesiones" },
                { name: 'Homicidio', data: 'Homicidio', title: "Homicidios" },
                { name: 'terminoDan', data: 'terminoDan', title: "Conclusión de Daños", formatter: [this, "formatearDanios"], orderable: false },
                { name: 'terminoLesHom', data: 'terminoLesHom', title: "Conclusión de Lesiones / Homicidio", formatter: [this, "formatearLesHom"], orderable: false },
                { name: 'valNegociacion', data: 'valNegociacion', title: "Conclusión de Negociaciones", formatter: [this, "formatearNegociaciones"], orderable: false },
                { name: 'editar', data: 'editar', title: "", formatter: [this, "formatearEditar"], orderable: false },

            ],
            displayInputs: {
                nrreporte: 0,
                svindice: 0
            },
            rulesO: [v => !!v || 'Campo requerido'],
            rulesInputsAnio: [(v) => {
                if (v == null || v == '') {
                    return true;
                } else {
                    if (v < 1920) {
                        return "Año mínimo " + 1920;
                    } else if (v > new Date().getFullYear() + 1) {
                        return "Año máximo " + (new Date().getFullYear() + 1);
                    } else return true;
                }
                return true
            }],
            rulesInputsNumber: [(v) => {
                if (v == null || v == '') {
                    return true;
                } else {
                    if (v.length > 7) {
                        return 'Monto Invalido'
                    }
                    else {
                        return new RegExp('^[0-9]+(\.[0-9]{1,2})?$').test(v) || "Inserte un valor valido"
                    }

                }
                return true
            }],
            rulestextarea: [//v => !!v || 'Campo requerido',
                v => {
                    if (v == null || v == '') {
                        return true
                    }
                    else {
                        if (v.length < 12) {
                            return 'Mínimo 12 Carácteres'
                        }
                        else if (v.length > this.$store.state.maxLengthComentarios) {
                            return "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres"
                        }
                        else
                            return true
                    }
                },
            ],
            formatterActions: [
                { click: [this, "editarTercerodisabled"] }
            ],
            updateTable: true,
            disabledbutton: false,
            edit: true,
            classdisabled: "disable-action",
            push: 0,
            showmontooficial: false,
            modal: false,
            firma: '',
            msg: false,
            texto: '',
            loading: false,
            permisoOfuscar: false,
        }
    },
    computed: {
        ...mapState(['domain', 'informationPage']),
    },
    watch: {
        'datos.d3sindatoanio'(val) {
            if (val) {
                this.validation.errorAnio = '';
            }
            else {
                this.datos.d3sindatoanio = false;

            }
        },
        'datos.d3danios'(val) {
            if (!val) {
                this.datos.d3sindatoanio = false;
                this.datos.montopendientedanios = false;
                this.valestdanios = true;
                this.classdisableddanios = "disable-action";
                this.validation.errorDaniosOcupante = false;
                this.validation.errorEstimadoDanios = '';
                this.validation = {
                    errorDelito: false,
                    errorDelitoLH: false,
                    errorDaniosOcupante: false,
                    errorHomicidioFuga: false,
                    errorLesiones: false,
                    errorTipoT: false,
                    errorEstadoT: false,
                    errorCompania: false,
                    errorCobertura: false,
                    errorMarca: false,
                    errorModelo: false,

                    errorNombre: '',
                    errorDomicilio: '',
                    errorAnio: '',
                    errorPlaca: '',
                    errorColor: '',
                    errorEstimadoDanios: '',
                    errorEstimadoLesiones: '',
                    errorPoliza: '',
                    errorSiniestro: '',
                    montoazul: '',
                }
                return;
            }
            else
                this.validation.errorAnio = '';

            if (this.datos.d3tipo == 'O') {
                this.validation.errorLesiones = false;
                this.validation.errorDelito = false;
                this.validation.errorDelitoLH = false;
                this.validation.errorDaniosOcupante = false;
                this.validation.errorHomicidioFuga = false;

                this.validation.errorDaniosOcupante = true;
            }
            if (!this.edit) {
                this.classdisableddanios = "";
                this.valestdanios = false;
            }
            else {
                this.classdisableddanios = "disable-action";
                this.valestdanios = true;
            }


        },
        'datos.d3lesiones'(val) {

            if (!val && !this.datos.d3homicidio) {
                this.datos.montopendientelesiones = false;
                this.datos.d3montoestles = null;
                this.valestlesiones = true;
                this.classdisabledlesiones = "disable-action";
                this.validation.errorDelitoLH = false;
                this.validation.errorEstimadoLesiones = '';
                this.validation.errorLesiones = false;
                return;
            }
            if (!val && this.datos.d3homicidio) {

                this.validation.errorDelitoLH = false;
                this.validation.errorEstimadoLesiones = '';
                this.validation.errorLesiones = false;
                return;
            }

            if (!this.edit) {
                this.classdisabledlesiones = "";
                this.valestlesiones = false;
            }
            else {
                this.classdisabledlesiones = "disable-action";
                this.valestlesiones = true;
            }






            this.validation.errorLesiones = false;
            if (this.datos.d3homicidio) {
                this.validation.errorLesiones = false;
                this.validation.errorDelito = false;
                this.validation.errorDelitoLH = false;
                this.validation.errorDaniosOcupante = false;
                this.validation.errorHomicidioFuga = false;

                this.validation.errorDelitoLH = true;
            }







        },
        'datos.d3homicidio'(val) {

            if (!val && !this.datos.d3lesiones) {
                this.datos.montopendientelesiones = false;
                this.datos.d3montoestles = null;
                this.valestlesiones = true;
                this.classdisabledlesiones = "disable-action";

                this.validation.errorDelitoLH = false;
                this.validation.errorHomicidioFuga = false;
                return;
            }
            if (!val && this.datos.d3lesiones) {
                this.validation.errorDelitoLH = false;
                this.validation.errorHomicidioFuga = false;
                return;
            }

            if (!this.edit) {
                this.classdisabledlesiones = "";
                this.valestlesiones = false;
            }
            else {
                this.classdisabledlesiones = "disable-action";
                this.valestlesiones = true;
            }

            if (this.datos.d3lesiones) {
                this.validation.errorLesiones = false;
                this.validation.errorDelito = false;
                this.validation.errorDelitoLH = false;
                this.validation.errorDaniosOcupante = false;
                this.validation.errorHomicidioFuga = false;

                this.validation.errorDelitoLH = true;
            }

            if (this.datos.d3situacion == 'F') {
                this.validation.errorLesiones = false;
                this.validation.errorDelito = false;
                this.validation.errorDelitoLH = false;
                this.validation.errorDaniosOcupante = false;
                this.validation.errorHomicidioFuga = false;

                this.validation.errorHomicidioFuga = true;
            }

        },
        async 'datos.mrclave'(val) {
            if (val != null) {
                Reporte.obtenerModelos(this, val.mrclave);
                if (this.datos.d3montoazul >= 1 && this.datos.d3montoazul < 15000) {
                    this.validation.montoazul = 'Monto Invalido';
                } else if (this.datos.d3montoazul > 2000000) {
                    this.validation.montoazul = 'Monto Invalido';
                }
                else {
                    this.validation.montoazul = '';
                }
            }
            else {
                this.datos.mdclave = null;
                this.opcionesModelos = [];
                this.validation.montoazul = '';
            }




            if (this.datos.d3situacion == "P" || this.datos.d3situacion == "U") {
                if (this.datos.d3danios && this.datos.d3tipo != 'I' && this.datos.d3tipo != 'P') {
                    if (this.datos.mrclave == null) {
                        this.validation.errorMarca = true;
                    } else {
                        this.validation.errorMarca = false;
                    }
                } else {
                    this.validation.errorMarca = false;
                }

            }
            else {
                this.validation.errorMarca = false;
            }

        },
        'datos.sttid'(val) {
            this.validaTipo = false;
        },
        'datos.montopendientelesiones'(val) {

            if (this.datos.d3situacion == "P" || this.datos.d3situacion == "U") {

                if (this.datos.d3lesiones || this.datos.d3homicidio) {
                    if ((this.datos.d3montoestles == null || this.datos.d3montoestles == '' || this.datos.d3montoestles == 0) && !this.datos.montopendientelesiones) {
                        this.validation.errorEstimadoLesiones = 'Indicar monto de lesiones  ó indicar monto pendiente';
                    }
                    else {
                        this.validation.errorEstimadoLesiones = '';
                        if ((this.datos.d3montoestles < 500) && !this.datos.montopendientelesiones) {
                            this.validation.errorEstimadoLesiones = 'Monto Invalido';
                        }
                        else {
                            this.validation.errorEstimadoLesiones = '';
                        }
                    }
                }
                else {
                    this.validation.errorEstimadoLesiones = '';
                }


            }
            else {
                this.validation.errorEstimadoLesiones = '';
            }

        },
        'datos.montopendientedanios'(val) {
            if (this.datos.d3situacion == "P" || this.datos.d3situacion == "U") {
                if (this.datos.d3danios && this.datos.d3tipo != 'I' && this.datos.d3tipo != 'P') {
                    if ((this.datos.d3montoest == null || this.datos.d3montoest == '' || this.datos.d3montoest == 0) && !this.datos.montopendientedanios) {
                        this.validation.errorEstimadoDanios = 'Indicar monto de daños ó indicar monto pendiente';
                    }
                    else {
                        this.validation.errorEstimadoDanios = '';
                    }
                } else {
                    this.validation.errorEstimadoDanios = '';
                }
            }
            else {
                this.validation.errorEstimadoDanios = '';
            }

        },
        'datos.d3montoest'(val) {

            if (this.datos.d3situacion == "P" || this.datos.d3situacion == "U") {
                if (this.datos.d3danios && this.datos.d3tipo != 'I' && this.datos.d3tipo != 'P') {
                    if ((this.datos.d3montoest == null || this.datos.d3montoest == '' || this.datos.d3montoest == 0) && !this.datos.montopendientedanios) {
                        this.validation.errorEstimadoDanios = 'Indicar monto de daños ó indicar monto pendiente';
                    }
                    else {
                        this.validation.errorEstimadoDanios = '';
                        if ((this.datos.d3montoest < 500) && !this.datos.montopendientedanios) {
                            this.validation.errorEstimadoDanios = 'Monto Invalido';
                        }
                        else {
                            this.validation.errorEstimadoDanios = '';
                        }
                    }
                } else {
                    this.validation.errorEstimadoDanios = '';
                    if (this.datos.d3danios && (this.datos.d3tipo == 'I' || this.datos.d3tipo == 'P')) {
                        if (this.datos.d3montoest < 500 && !this.datos.montopendientedanios) {//no es obligatorio pero si coloca valor lo valida
                            this.validation.errorEstimadoDanios = 'Monto Invalido';
                        }
                        else {
                            this.validation.errorEstimadoDanios = '';
                        }
                    }
                }
            }
            else {
                this.validation.errorEstimadoDanios = '';
            }


        },
        'datos.d3montoestles'(val) {

            if (this.datos.d3situacion == "P" || this.datos.d3situacion == "U") {
                if (this.datos.d3lesiones || this.datos.d3homicidio) {
                    if ((this.datos.d3montoestles == null || this.datos.d3montoestles == '' || this.datos.d3montoestles == 0) && !this.datos.montopendientelesiones) {
                        this.validation.errorEstimadoLesiones = 'Indicar monto de lesiones ó indicar monto pendiente';
                    }
                    else {
                        this.validation.errorEstimadoLesiones = '';
                        if ((this.datos.d3montoestles < 500) && !this.datos.montopendientelesiones) {
                            this.validation.errorEstimadoLesiones = 'Monto Invalido';
                        }
                        else {
                            this.validation.errorEstimadoLesiones = '';
                        }
                    }
                }
                else {
                    this.validation.errorEstimadoLesiones = '';
                }

            }
            else {
                this.validation.errorEstimadoLesiones = '';
            }


        },
        'datos.d3color'(val) {
            if (this.datos.d3situacion == "P" || this.datos.d3situacion == "U") {
                if (this.datos.d3danios && this.datos.d3tipo != 'I' && this.datos.d3tipo != 'P') {
                    if (this.datos.d3color == null || this.datos.d3color == '') {
                        this.validation.errorColor = 'Campo requerido';
                    } else {
                        this.validation.errorColor = '';
                    }
                } else {
                    this.validation.errorColor = '';
                }

            }
            else {
                this.validation.errorColor = '';
            }


        },

        'datos.d3placa'(val) {
            if (this.datos.d3situacion == "P" || this.datos.d3situacion == "U") {
                if (this.datos.d3danios && this.datos.d3tipo != 'I' && this.datos.d3tipo != 'P') {
                    if (this.datos.d3placa == null || this.datos.d3placa == '') {
                        this.validation.errorPlaca = 'Campo requerido';
                    } else {
                        this.validation.errorPlaca = '';
                    }
                } else {
                    this.validation.errorPlaca = '';
                }

            }
            else {
                this.validation.errorPlaca = '';
            }


        },
        'datos.d3anio'(val) {
            if (this.datos.d3situacion == "P" || this.datos.d3situacion == "U") {
                if (this.datos.d3danios && this.datos.d3tipo != 'I' && this.datos.d3tipo != 'P') {
                    if ((this.datos.d3anio == null || this.datos.d3anio == '') && this.datos.d3sindatoanio == false) {
                        this.validation.errorAnio = 'Indicar el año  ó indicar sin datos del vehículo';// 'Campo requerido';
                    } else {
                        this.validation.errorAnio = '';
                    }
                } else {
                    this.validation.errorAnio = '';
                }

            }
            else {
                this.validation.errorAnio = '';
            }


        },
        'datos.mdclave'(val) {
            if (this.datos.d3situacion == "P" || this.datos.d3situacion == "U") {
                if (this.datos.d3danios && this.datos.d3tipo != 'I' && this.datos.d3tipo != 'P') {
                    if (this.datos.mdclave == null) {
                        this.validation.errorModelo = true;
                    } else {
                        this.validation.errorModelo = false;
                    }
                } else {
                    this.validation.errorModelo = false;
                }

            }
            else {
                this.validation.errorModelo = false;
            }


        },
        'datos.d3tipo'(val) {
            if (val == 'T' && (this.datos.d3situacion == 'P' || this.datos.d3situacion == 'U')) {
                this.showVh = true;
            }
            else {
                this.showVh = false;
                this.datos.d3vehdet = null;
                this.datos.d3acreditaVh = null;
                this.datos.d3tpersona = null;
                this.check = 2;
            }
            if (val == 'O' && this.datos.d3danios) {
                this.validation.errorLesiones = false;
                this.validation.errorDelito = false;
                this.validation.errorDelitoLH = false;
                this.validation.errorDaniosOcupante = false;
                this.validation.errorHomicidioFuga = false;

                this.validation.errorDaniosOcupante = true;
            }
            else {
                this.validation.errorDaniosOcupante = false;
            }

            if (this.datos.d3situacion == "P" || this.datos.d3situacion == "U") {
            } else {
                this.validation.errorNombre = '';
                this.validation.errorDomicilio = '';
                this.validation.errorMarca = false;
                this.validation.errorModelo = false;
                this.validation.errorAnio = '';
                this.validation.errorPlaca = '';
                this.validation.errorColor = '';
                this.validation.errorEstimadoDanios = '';
                this.validation.errorEstimadoLesiones = '';
            }



        },
        'datos.d3situacion'(val) {
            if (this.datos.d3tipo == 'T' && (val == 'P' || val == 'U')) {
                this.showVh = true;
            }
            else {
                this.showVh = false;
                this.datos.d3vehdet = null;
                this.datos.d3acreditaVh = null;
                this.datos.d3tpersona = null;
                this.check = 2;
            }

            if (val == 'F' && this.datos.d3homicidio) {
                this.validation.errorLesiones = false;
                this.validation.errorDelito = false;
                this.validation.errorDelitoLH = false;
                this.validation.errorDaniosOcupante = false;
                this.validation.errorHomicidioFuga = false;

                this.validation.errorHomicidioFuga = true;
            }
            else {
                this.validation.errorHomicidioFuga = false;
            }

            if (this.datos.d3situacion == "P" || this.datos.d3situacion == "U") {


            }
            else {
                this.validation.errorNombre = '';
                this.validation.errorDomicilio = '';
                this.validation.errorMarca = false;
                this.validation.errorModelo = false;
                this.validation.errorAnio = '';
                this.validation.errorPlaca = '';
                this.validation.errorColor = '';
                this.validation.errorEstimadoDanios = '';
                this.validation.errorEstimadoLesiones = '';
            }
        },
        'datos.d3nombre'(val) {
            if (this.datos.d3situacion == "P" || this.datos.d3situacion == "U") {
                if (this.datos.d3nombre == null || this.datos.d3nombre == '') {
                    this.validation.errorNombre = 'Campo requerido';
                } else {
                    this.validation.errorNombre = '';
                }
            } else {
                this.validation.errorNombre = '';
            }
        },
        'datos.dedirec'(val) {
            if (this.datos.d3situacion == "P" || this.datos.d3situacion == "U") {
                if ((this.datos.dedirec == null || this.datos.dedirec == '') && this.datos.d3tipo != 'I') {
                    this.validation.errorDomicilio = 'Campo requerido';
                } else {
                    this.validation.errorDomicilio = '';
                }
            } else {
                this.validation.errorDomicilio = '';
            }
        },
        'datos.d3siniestro'(val) {
            if (this.datos.aseclave == null) {
                this.validation.errorCompania = false;
            }
            else {
                this.validation.errorCompania = false;
                if (this.datos.aseclave.aseclave != 0 && this.datos.aseclave != null) {

                    if (val == null || val == '') {
                        this.validation.errorSiniestro = 'Ingrese el numero de siniestro';
                    } else {
                        this.validation.errorSiniestro = '';
                    }

                }
                else {
                    this.validation.errorCobertura = false;
                    this.validation.errorSiniestro = '';
                    this.validation.errorPoliza = '';
                }
            }

        },
        'datos.d3poliza'(val) {
            if (this.datos.aseclave == null) {
                this.validation.errorCompania = false;
            }
            else {
                this.validation.errorCompania = false;
                if (this.datos.aseclave.aseclave != 0 && this.datos.aseclave != null) {

                    if (val == null || val == '') {
                        this.validation.errorPoliza = 'Ingrese el numero de póliza';
                    } else {
                        this.validation.errorPoliza = '';
                    }
                }
                else {
                    this.validation.errorCobertura = false;
                    this.validation.errorSiniestro = '';
                    this.validation.errorPoliza = '';
                }
            }


        },

        'datos.d3montoazul'(val) {
            this.validation.montoazul = '';
            if (this.datos.mrclave != null) {
                if (val == 0 || val == '' || val == null) {
                    this.validation.montoazul = 'Ingresar un Monto';
                }
                else if (val >= 1 && val < 15000) {
                    this.validation.montoazul = 'Monto Invalido';
                } else if (val > 2000000) {
                    this.validation.montoazul = 'Monto Invalido';
                }
                else {
                    this.validation.montoazul = '';
                }
            }
            else {
                this.validation.montoazul = '';
            }

            if (val >= 1 && val < 15000) {
                this.validation.montoazul = 'Monto Invalido';
            } else if (val > 2000000) {
                this.validation.montoazul = 'Monto Invalido';
            }
            else {
                this.validation.montoazul = '';
            }


        },
        'datos.aseclave'(val) {
            if (val == null) {
                this.validation.errorCompania = false;
                if (!this.edit) {
                    this.valaseguradora = false;
                }
                else {
                    this.valaseguradora = true;
                }

            }
            else {
                this.validation.errorCompania = false;
                if (val.aseclave != 0 && val != null) {
                    if (!this.edit) {
                        this.valaseguradora = false;
                    }
                    else {
                        this.valaseguradora = true;
                    }

                }
                else {

                    this.valaseguradora = true;
                    this.datos.d3tipocob = null;
                    this.datos.d3siniestro = null;
                    this.datos.d3poliza = null;



                    this.validation.errorCobertura = false;
                    this.validation.errorSiniestro = '';
                    this.validation.errorPoliza = '';
                }
            }


        },
        'datos.d3tipocob'(val) {
            if (this.datos.aseclave == null) {
                this.validation.errorCompania = false;
            }
            else {
                this.validation.errorCompania = false;
                if (this.datos.aseclave.aseclave != 0 && this.datos.aseclave != null) {
                    if (val == null) {
                        this.validation.errorCobertura = true;
                    } else {
                        this.validation.errorCobertura = false;
                    }
                }
                else {
                    this.validation.errorCobertura = false;
                    this.validation.errorSiniestro = '';
                    this.validation.errorPoliza = '';
                }
            }


        },

    },
    methods: {
        filterme(value) {
            value = parseInt(value.target.value, 10); // Convert to an integer
            this.check = value;
            var customToggle = document.getElementById('custom-toggle');
            if (value === 3) {
                customToggle.classList.remove('tgl-off', 'tgl-def');
                customToggle.classList.add('tgl-on');
                this.datos.d3acreditaVh = 1;
            } else if (value === 2) {
                customToggle.classList.remove('tgl-on', 'tgl-off');
                customToggle.classList.add('tgl-def');
                this.datos.d3acreditaVh = null;
            } else if (value === 1) {
                customToggle.classList.remove('tgl-def', 'tgl-on');
                customToggle.classList.add('tgl-off');
                this.datos.d3acreditaVh = 0;
            }
        },
        VerModal(item, index, tipo) {
            this.numtele = item.stprefijo + ' ' + item.stnumero;
            this.verTelefono = index;
            this.modal = true;
            this.tipoTel = tipo;
        },
        CerrarModal() {
            this.modal = false;
            this.firma = '';
            this.texto = '';
        },
        OcultaTel(item, index, tipo) {
            this.telefonos[this.verTelefono].banderaview = 'false';
        },
        ValidarFirma() {
            let formdatos = new FormData();
            formdatos.append("usfirma", this.firma);
            formdatos.append("telefono", this.numtele);
            if (this.firma.length == 0) {
                this.msg = true;
                this.texto = 'Campo de rquerido';
            }
            else if (this.firma.length < 8 || this.firma.length > 16) {
                this.msg = true;
                this.texto = 'El número de caracteres debe ser un mínimo de 8 y menor a 17';
            }
            else {
                this.loading = true;
                Contacto.ValidaFirmaElectronica(this, formdatos).then(dato => {
                    if (dato == 0) {
                        this.msg = true;
                        this.texto = 'Su firma electrónica es incorrecta';
                    }
                    else {
                        this.telefonos[this.verTelefono].banderaview = 'true';

                        this.modal = false;
                        this.veri = false;
                    }
                    this.firma = '';
                    this.loading = false;
                });
            }
        },
        Foco() {
            this.msg = false;
        },
        async irConcluirDanos() {
            if (this.push == 0) {

                if (this.datos.valmontopendientedanios) {
                    this.$swal({
                        position: 'center',
                        icon: 'warning',
                        title: 'No puede concluir daños, hasta agregar un monto pendiente',
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    })
                    return
                }

                this.push++;
                var datareporte = await MetodosGenerales.obtenerSessionReporte('reporte');

                var reporte = datareporte;

                var tercero = {
                    d3id: this.d3id,
                };
                const finalResult = Object.assign(reporte, tercero);
                finalResult.urlname = this.$route.name;
                await MetodosGenerales.guardarEnSesionInfoReporte(finalResult, 'reporte');
                //this.$router.push({ name: 'ConcluirDanos' });

                let asistenciaurl = await MetodosGenerales.ObtenerURL(this.displayInputs);
                this.$router.push({ path: asistenciaurl + '/ConcluirDanos' });

            }
        },
        async verConcluirDanos() {
            if (this.push == 0) {
                this.push++;
                var datareporte = await MetodosGenerales.obtenerSessionReporte('reporte');

                var reporte = datareporte;

                var tercero = {
                    d3id: this.d3id,
                };
                const finalResult = Object.assign(reporte, tercero);
                finalResult.urlname = this.$route.name;
                await MetodosGenerales.guardarEnSesionInfoReporte(finalResult, 'reporte');
                //this.$router.push({ name: 'InfoConclusionDanos' });

                let asistenciaurl = await MetodosGenerales.ObtenerURL(this.displayInputs);
                this.$router.push({ path: asistenciaurl + '/InfoConclusionDanos' });
            }
        },
        async irConcluirLesiones() {
            if (this.push == 0) {

                if (this.datos.valmontopendienteleshom) {
                    this.$swal({
                        position: 'center',
                        icon: 'warning',
                        title: 'No puede concluir Lesiones/Homicidios, hasta agregar un monto pendiente',
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    })
                    return
                }


                this.push++;
                var datareporte = await MetodosGenerales.obtenerSessionReporte('reporte');

                var reporte = datareporte;

                var tercero = {
                    d3id: this.d3id,
                };
                const finalResult = Object.assign(reporte, tercero);
                finalResult.urlname = this.$route.name;
                await MetodosGenerales.guardarEnSesionInfoReporte(finalResult, 'reporte');
                //this.$router.push({ name: 'ConcluirLesiones' });

                let asistenciaurl = await MetodosGenerales.ObtenerURL(this.displayInputs);
                this.$router.push({ path: asistenciaurl + '/ConcluirLesiones' });
            }
        },
        async verConcluirLesiones() {
            if (this.push == 0) {
                this.push++;
                var datareporte = await MetodosGenerales.obtenerSessionReporte('reporte');

                var reporte = datareporte;

                var tercero = {
                    d3id: this.d3id,
                };
                const finalResult = Object.assign(reporte, tercero);
                finalResult.urlname = this.$route.name;
                await MetodosGenerales.guardarEnSesionInfoReporte(finalResult, 'reporte');
                //this.$router.push({ name: 'InfoConclusionLesiones' });

                let asistenciaurl = await MetodosGenerales.ObtenerURL(this.displayInputs);
                this.$router.push({ path: asistenciaurl + '/InfoConclusionLesiones' });
            }
        },
        async irNegociaciones() {
            if (this.push == 0) {
                this.push++;
                var datareporte = await MetodosGenerales.obtenerSessionReporte('reporte');

                var reporte = datareporte;

                var tercero = {
                    d3id: this.d3id,
                };
                const finalResult = Object.assign(reporte, tercero);
                finalResult.urlname = this.$route.name;
                await MetodosGenerales.guardarEnSesionInfoReporte(finalResult, 'reporte');
                //this.$router.push({ name: 'ListadoNegociaciones' });

                let asistenciaurl = await MetodosGenerales.ObtenerURL(this.displayInputs);
                this.$router.push({ path: asistenciaurl + '/ListadoNegociaciones' });
            }

        },
        async guardarEdicionTercero() {
            this.disabledSave = true;
            await this.$refs.form.validate();
            if (this.validar() && this.$refs.form.validate()) {
                this.$swal({
                    position: 'center',
                    title: 'Editando datos del Tercero ...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                });

                await Reporte.modificarTerceros(this).then(response => {
                    this.$store.commit("changeAsegurado", 0);
                    setTimeout(() => {
                        this.$swal.close();
                        if (response) {
                            this.updateTable = false;
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Se editó correctamente el Tercero',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    this.$store.commit("changeAsegurado", 1);
                                    this.disabledSave = false;
                                    this.updateTable = true;
                                    this.cancelar();
                                    this.$emit("reload", true);
                                }
                            });

                        }
                        else {
                            this.$swal({
                                position: 'center',
                                icon: 'error',
                                title: 'Error',
                                text: 'Hubo un error al editar el Tercero, Favor de avisar a Desarrollo',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            })
                        }
                    }, 2000);
                });

            }
            else {
                this.disabledSave = false;

            }
        },
        async guardarNuevoTercero() {

            this.disabledSave = true;
            await this.$refs.form.validate();

            if (this.validar() && this.$refs.form.validate()) {
                this.$swal({
                    position: 'center',
                    title: 'Guardando datos del Tercero ...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                });
                await Reporte.guardarTercero(this).then(response => {
                    this.$store.commit("changeAsegurado", 0);
                    setTimeout(() => {
                        this.$swal.close();
                        if (response) {
                            this.updateTable = false;
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Se guardó correctamente el Tercero',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    this.$store.commit("changeAsegurado", 1);
                                    this.disabledSave = false;
                                    this.updateTable = true;
                                    this.cancelar();
                                    this.$emit("reload", true);
                                }
                            });

                        }
                        else {
                            this.$swal({
                                position: 'center',
                                icon: 'error',
                                title: 'Error',
                                text: 'Hubo un error al guardar el Tercero, Favor de avisar a Desarrollo',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            })
                        }

                    }, 2000);

                });



            }
            else {
                this.disabledSave = false;
            }
        },
        validar() {
            let conterror = 0;

            if (this.datos.d3lesiones && this.datos.d3lesionesclave == null) {
                conterror++;
                this.validation.errorLesiones = false;
                this.validation.errorDelito = false;
                this.validation.errorDelitoLH = false;
                this.validation.errorDaniosOcupante = false;
                this.validation.errorHomicidioFuga = false;

                this.validation.errorLesiones = true;
            }
            if (!this.datos.d3danios && !this.datos.d3lesiones && !this.datos.d3homicidio) {
                conterror++;
                this.validation.errorLesiones = false;
                this.validation.errorDelito = false;
                this.validation.errorDelitoLH = false;
                this.validation.errorDaniosOcupante = false;
                this.validation.errorHomicidioFuga = false;

                this.validation.errorDelito = true;
            }
            if (this.datos.d3lesiones && this.datos.d3homicidio) {
                conterror++;
                this.validation.errorLesiones = false;
                this.validation.errorDelito = false;
                this.validation.errorDelitoLH = false;
                this.validation.errorDaniosOcupante = false;
                this.validation.errorHomicidioFuga = false;

                this.validation.errorDelitoLH = true;

            }
            if (this.datos.d3danios && this.datos.d3tipo == 'O') {
                conterror++;
                this.validation.errorLesiones = false;
                this.validation.errorDelito = false;
                this.validation.errorDelitoLH = false;
                this.validation.errorDaniosOcupante = false;
                this.validation.errorHomicidioFuga = false;

                this.validation.errorDaniosOcupante = true;
            }

            if (this.datos.d3homicidio && this.datos.d3situacion == 'F') {
                conterror++;
                this.validation.errorLesiones = false;
                this.validation.errorDelito = false;
                this.validation.errorDelitoLH = false;
                this.validation.errorDaniosOcupante = false;
                this.validation.errorHomicidioFuga = false;

                this.validation.errorHomicidioFuga = true;
            }

            if (this.datos.d3tipo == null) {
                conterror++;
                this.validation.errorTipoT = true;
            }

            if (this.datos.d3situacion == null) {
                conterror++;
                this.validation.errorEstadoT = true;
            }

            if (this.datos.mrclave != null) {  //cuando se haya seleccionado marca entra aquí
                if (this.datos.d3montoazul == 0 || this.datos.d3montoazul == '' || this.datos.d3montoazul == null) {
                    conterror++;
                    this.validation.montoazul = 'Ingresar un Monto';
                }
                else if (this.datos.d3montoazul >= 1 && this.datos.d3montoazul < 15000) {
                    conterror++;
                    this.validation.montoazul = 'Monto Invalido';
                } else if (this.datos.d3montoazul > 2000000) {
                    conterror++;
                    this.validation.montoazul = 'Monto Invalido';
                }
            }
            if (this.datos.d3montoazul >= 1 && this.datos.d3montoazul < 15000) {
                conterror++;
                this.validation.montoazul = 'Monto Invalido';
            } else if (this.datos.d3montoazul > 2000000) {
                conterror++;
                this.validation.montoazul = 'Monto Invalido';
            }

            if (this.datos.aseclave == null) {
                conterror++;
                this.validation.errorCompania = true;
            }
            else {
                if (this.datos.aseclave.aseclave != 0 && this.datos.aseclave != null) {
                    if (this.datos.d3tipocob == null) {
                        conterror++;
                        this.validation.errorCobertura = true;
                    }
                    if (this.datos.d3siniestro == null || this.datos.d3siniestro == '') {
                        conterror++;
                        this.validation.errorSiniestro = 'Ingrese el numero de siniestro';
                    }
                    if (this.datos.d3poliza == null || this.datos.d3poliza == '') {
                        conterror++;
                        this.validation.errorPoliza = 'Ingrese el numero de póliza';
                    }
                }
                else {
                    this.validation.errorCobertura = false;
                    this.validation.errorSiniestro = '';
                    this.validation.errorPoliza = '';
                }

            }
            if (this.datos.d3situacion == "P" || this.datos.d3situacion == "U") {
                if (this.datos.d3nombre == null || this.datos.d3nombre == '') {
                    conterror++;
                    this.validation.errorNombre = 'Campo requerido';
                } else {
                    this.validation.errorNombre = '';
                }
                if ((this.datos.dedirec == null || this.datos.dedirec == '') && this.datos.d3tipo != 'I') {
                    conterror++;
                    this.validation.errorDomicilio = 'Campo requerido';
                } else {
                    this.validation.errorDomicilio = '';
                }

                if (this.datos.d3danios && this.datos.d3tipo != 'I' && this.datos.d3tipo != 'P') {
                    if (this.datos.mrclave == null) {
                        conterror++;
                        this.validation.errorMarca = true;
                    } else {
                        this.validation.errorMarca = false;
                    }
                    if (this.datos.mdclave == null) {
                        conterror++;
                        this.validation.errorModelo = true;
                    } else {
                        this.validation.errorModelo = false;
                    }
                    if ((this.datos.d3anio == null || this.datos.d3anio == '') && this.datos.d3sindatoanio == false) {
                        conterror++;
                        this.validation.errorAnio = 'Indicar el año  ó indicar sin datos del vehículo';//'Campo requerido';
                    } else {
                        this.validation.errorAnio = '';
                    }
                    if (this.datos.d3placa == null || this.datos.d3placa == '') {
                        conterror++;
                        this.validation.errorPlaca = 'Campo requerido';
                    } else {
                        this.validation.errorPlaca = '';
                    }
                    if (this.datos.d3color == null || this.datos.d3color == '') {
                        conterror++;
                        this.validation.errorColor = 'Campo requerido';
                    } else {
                        this.validation.errorColor = '';
                    }
                    if ((this.datos.d3montoest == null || this.datos.d3montoest == '' || this.datos.d3montoest == 0) && !this.datos.montopendientedanios) {
                        conterror++;
                        this.validation.errorEstimadoDanios = 'Indicar monto de daños ó indicar monto pendiente';
                    }
                    else {
                        this.validation.errorEstimadoDanios = '';
                        if ((this.datos.d3montoest < 500) && !this.datos.montopendientedanios) {
                            conterror++;
                            this.validation.errorEstimadoDanios = 'Monto Invalido';
                        }
                        else {
                            this.validation.errorEstimadoDanios = '';
                        }
                    }
                    //montoazul no es obligatorio solo si agrega valor se valida
                    if (this.datos.d3montoazul >= 1 && this.datos.d3montoazul < 15000) {
                        conterror++;
                        this.validation.montoazul = 'Monto Invalido';
                    } else if (this.datos.d3montoazul > 2000000) {
                        conterror++;
                        this.validation.montoazul = 'Monto Invalido';
                    }

                }
                else if (this.datos.d3danios && (this.datos.d3tipo == 'I' || this.datos.d3tipo == 'P')) {
                    if (this.datos.d3montoest < 500 && !this.datos.montopendientedanios) {//no es obligatorio pero si coloca valor lo valida
                        conterror++;
                        this.validation.errorEstimadoDanios = 'Monto Invalido';
                    }
                    else {
                        this.validation.errorEstimadoDanios = '';
                    }
                }

                if (this.datos.d3lesiones) {//|| this.datos.d3homicidio
                    if ((this.datos.d3montoestles == null || this.datos.d3montoestles == '' || this.datos.d3montoestles == 0) && !this.datos.montopendientelesiones) {
                        conterror++;
                        this.validation.errorEstimadoLesiones = 'Indicar monto de lesiones ó indicar monto pendiente';
                    }
                    else {
                        this.validation.errorEstimadoLesiones = '';
                        if ((this.datos.d3montoestles < 500) && !this.datos.montopendientelesiones) {
                            conterror++;
                            this.validation.errorEstimadoLesiones = 'Monto Invalido';
                        }
                        else {
                            this.validation.errorEstimadoLesiones = '';
                        }
                    }
                }
            }

            if (conterror > 0) {
                return false;
            }


            return true;


        },
        eliminaTelfAlta(item, index) {
            this.telefonos.splice(index, 1);
        },
        validaNuevos(nuevo) {
            var val = 0;
            var valido = true;
            for (var i = 0; i < this.telefonos.length; i++) {

                if (nuevo == this.telefonos[i]["stnumero"]) {
                    val++;
                }
            }
            if (val > 0) { valido = false }

            return valido;
        },
        altaTelefonoGuardar() {
            this.disabledsaveTelf = true;
            let cont = 0;

            if (this.datos.sttid == null) {
                cont++;
                this.validaTipo = true;
                this.disabledsaveTelf = false;
            }
            if (!this.phone.valid) {
                cont++;
                this.errorTelf.push("Teléfono Inválido");
                this.disabledsaveTelf = false;
            }
            if (cont == 0) {
                if (this.validaNuevos(this.datos.numtelf.split(/\s+/).join(''))) {
                    this.telefonos.push({
                        stadescripcion: "Tercero",
                        staid: 5,
                        sttdescripcion: this.datos.sttid.sttdescripcion,
                        icon: this.datos.sttid.icon,
                        title: this.datos.sttid.sttdescripcion,
                        sttid: this.datos.sttid.sttid,
                        prefijo: "(+" + this.prefijo + ") ",
                        stnumero: this.datos.numtelf.split(/\s+/).join(''),
                        stnumero2: this.datos.numtelf2.split(/\s+/).join(''),
                        country: this.pais,
                        stprefijo: this.prefijo,
                        banderaview: 'false'
                    })
                    this.cancelarTelefono();
                }
                else {
                    this.$swal({
                        position: 'center',
                        icon: 'warning',
                        title: 'El número de teléfono ya existe.',
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.disabledsaveTelf = false;
                        }
                    })


                }


            }
        },
        async editaTelefonoGuardar() {

            this.disabledsaveTelf = true;
            let cont = 0;
            if (this.datos.sttid.sttid == this.datosTelefono.sttid && this.datos.numtelf.split(/\s+/).join('') == this.datosTelefono.stnumero) {
                this.$swal({
                    position: 'center',
                    icon: 'warning',
                    title: 'Advertencia',
                    text: 'Tiene que modificar al menos un campo',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                })
                this.disabledsaveTelf = false;

                return
            }



            if (this.datos.sttid == null) {
                cont++;
                this.validaTipo = true;
                this.disabledsaveTelf = false;
            }
            if (!this.phone.valid) {
                cont++;
                this.errorTelf.push("Teléfono Inválido");
                this.disabledsaveTelf = false;
            }

            if (cont == 0) {
                this.$swal({
                    position: 'center',
                    title: 'Editando teléfono ...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                });

                await Reporte.editarTelefonoTercero(this).then(response => {


                    setTimeout(() => {
                        this.$swal.close();
                        this.disabledsaveTelf = false;

                        if (response == "") {
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Se editó el teléfono correctamente',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    this.cancelarTelefono();
                                    Reporte.obtenerTelefonosTercero(this, this.d3id).then(datostel => {
                                        this.telefonos = []
                                        let auxtelefonos = datostel;
                                        for (let i in auxtelefonos) {
                                            for (const [key, value] of Object.entries(auxtelefonos[i])) {
                                                if (typeof value == "object") { auxtelefonos[i][key] = "" } else { auxtelefonos[i][key] = value.toString() }
                                            }
                                        }
                                        this.telefonos = auxtelefonos;
                                    });
                                }
                            })
                        }
                        else {
                            this.$swal({
                                position: 'center',
                                icon: 'warning',
                                title: response,
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                }
                            })

                        }

                    }, 2000);




                });




            }
        },
        editarTelf(item, index) {
            this.cancelarTelefono();
            Reporte.obtenerTipoTelefono(this);
            setTimeout(() => {
                this.prefijo = item.stprefijo;
                this.pais = item.country;
                this.datosTelefono = item;
                this.errorTelf = [];
                this.agregarEditTelefonos = true;
                this.vguardaedita = false;
                this.datos.sttid = { sttid: parseInt(item.sttid), sttdescripcion: item.title };
                this.datos.numtelf = item.stnumero;
                this.datos.numtelf2 = item.stnumero;
            }, 100);

        },
        async guardarTelefono() {
            this.disabledsaveTelf = true;
            let cont = 0;

            if (this.datos.sttid == null) {
                cont++;
                this.validaTipo = true;
                this.disabledsaveTelf = false;
            }
            if (!this.phone.valid) {
                cont++;
                this.errorTelf.push("Teléfono Inválido");
                this.disabledsaveTelf = false;
            }
            if (cont == 0) {
                this.$swal({
                    position: 'center',
                    title: 'Agregando teléfono ...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                });


                await Reporte.guardarTelefonoTercero(this).then(response => {


                    setTimeout(() => {
                        this.$swal.close();
                        this.disabledsaveTelf = false;

                        if (response == "") {
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Se agregó el teléfono correctamente',
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    this.cancelarTelefono();
                                    Reporte.obtenerTelefonosTercero(this, this.d3id).then(datostel => {
                                        this.telefonos = []
                                        let auxtelefonos = datostel;
                                        for (let i in auxtelefonos) {
                                            for (const [key, value] of Object.entries(auxtelefonos[i])) {
                                                if (typeof value == "object") { auxtelefonos[i][key] = "" } else { auxtelefonos[i][key] = value.toString() }
                                            }
                                        }
                                        this.telefonos = auxtelefonos;
                                    });
                                }
                            })
                        }
                        else {
                            this.$swal({
                                position: 'center',
                                icon: 'warning',
                                title: response,
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                }
                            })

                        }

                    }, 2000);




                });
            }


        },
        countryChanged(country) {
            this.prefijo = country.dialCode;
            this.pais = country.iso2;
        },
        onInput(formattedNumber, { number, valid, country }) {

            if (number.input == number.national) {
                this.errorTelf = [];
                this.phone.number = number.national;
                this.phone.valid = valid;
                this.phone.country = country && country.name;
                this.datos.numtelf2 = number.national.replace(/[^0-9]+/g, "");
            }
            else {
                this.errorTelf.push("Teléfono Inválido");
                this.phone.number = number.national;
                this.phone.valid = false;
                this.phone.country = country && country.name;
            }

        },
        cancelarTelefono() {
            this.agregarEditTelefonos = false;
            this.datos.sttid = null;
            this.datos.numtelf = null;
            this.datos.numtelf2 = null;
            this.phone = {
                number: null,
                valid: false,
                country: null
            };
            this.prefijo = null;
            this.pais = 'MX';
            this.validTelf = true;
            this.validaTipo = false;
            this.disabledsaveTelf = false;
            this.vguardaedita = true;
            this.datosTelefono = null;


        },
        agregarTelefono() {
            this.errorTelf = [];
            Reporte.obtenerTipoTelefono(this);
            this.agregarEditTelefonos = true;
            this.vguardaedita = true;


        },
        async editarTercerodisabled(params, item, fila) {
            this.cancelarTelefono();
            this.vagregarTelefonos = false;

            this.classdisableanio = '';

            this.d3id = item.d3id;
            this.valestdanios = true;
            this.valestlesiones = true;
            this.classdisableddanios = "disable-action";
            this.classdisabledlesiones = "disable-action";
            this.valAlta = false;

            this.edit = true;
            this.classdisabled = "disable-action";

            this.detalleTercero(item.d3id, 1);

            this.edit = false;
            this.classdisabled = '';
            setTimeout(() => {
                this.activeTelefonosdet = true;
                this.valEdit = true;
            }, 1000);



        },
        async detalleTercero(d3id, editar) {

            /*var d3id = 239762;*/
            this.cancelar();
            this.d3id = d3id;




            if (d3id != null) {
                this.cancelarTelefono();
                this.vagregarTelefonos = false;
                let datosTercero = await Reporte.obtenerDatosTercero(this, d3id);

                Object.keys(datosTercero[0]).map(key => {
                    if (typeof datosTercero[0][key] == "object") {
                        if (this.datos.hasOwnProperty(key)) {
                            this.datos[key] = null;
                        }
                    } else {
                        if (this.datos.hasOwnProperty(key)) {
                            this.datos[key] = datosTercero[0][key];
                        }
                    }
                })
                if (this.datos.mrclave != null) {//marca
                    this.datos.mrclave = { mrclave: datosTercero[0].mrclave, mrnombre: datosTercero[0].mrnombre };
                }
                if (this.datos.mdclave != null) {//modelo
                    this.datos.mdclave = { mdclave: datosTercero[0].mdclave, mdnombre: datosTercero[0].mdnombre };
                }
                if (this.datos.aseclave != null) {//aseguradora
                    this.datos.aseclave = { aseclave: datosTercero[0].aseclave, asenombre: datosTercero[0].asenombre };
                }




                if (datosTercero[0].d3tipocob != "object") {
                    if (datosTercero[0].d3tipocob == 'A') {
                        this.datos.d3tipocob = {
                            d3tipocob: "A",
                            text: "Amplia"
                        };
                    }
                    else if (datosTercero[0].d3tipocob == 'L') {
                        this.datos.d3tipocob = {
                            d3tipocob: "L",
                            text: "Limitada"
                        };
                    }
                    else {
                        this.datos.d3tipocob = null;
                    }
                }
                if (editar == 1) {
                    if (datosTercero[0].terminoDan == 'No' || datosTercero[0].terminoDan == 'Ya') {
                        this.valestdanios = false;
                        this.classdisableddanios = '';
                    }
                    if (datosTercero[0].terminoLesHom == 'No' || datosTercero[0].terminoLesHom == 'Ya') {
                        this.valestlesiones = false;
                        this.classdisabledlesiones = '';
                    }
                    this.classdisableanio = '';

                }
                else {
                    if (datosTercero[0].d3danios && datosTercero[0].terminoDan == 'No' && datosTercero[0].valNegociacion == 1) {
                        this.valdanos = true;
                    }
                    if (datosTercero[0].d3danios && datosTercero[0].terminoDan == 'Ya') {
                        this.valdanosVer = true;
                    }

                    if ((datosTercero[0].d3lesiones || datosTercero[0].d3homicidio) && datosTercero[0].terminoLesHom == 'No' && datosTercero[0].valNegociacion == 1) {
                        this.valleshom = true;
                    }
                    if ((datosTercero[0].d3lesiones || datosTercero[0].d3homicidio) && datosTercero[0].terminoLesHom == 'Ya') {
                        this.valleshomVer = true;
                    }
                }

                if (datosTercero[0].d3vehdet == 1) {
                    this.datos.d3vehdet = "1";
                }
                else if (datosTercero[0].d3vehdet == 0) {
                    this.datos.d3vehdet = "0";
                }
                else {
                    this.datos.d3vehdet = null;
                }

                if (datosTercero[0].d3tpersona == 0) {
                    this.datos.d3tpersona = "0";
                }
                else if (datosTercero[0].d3tpersona == 1) {
                    this.datos.d3tpersona = "1";
                }
                else {
                    this.datos.d3tpersona = null;
                }


                this.datos.d3acreditaVh = null;

                setTimeout(() => {
                    if (this.datos.d3tipo == 'T' && (this.datos.d3situacion == 'P' || this.datos.d3situacion == 'U')) {
                        var customToggle = document.getElementById('custom-toggle');
                        if (datosTercero[0].d3acreditaVh == 1) { //si en base tiene 1 en sistema es 3
                            customToggle.classList.remove('tgl-off', 'tgl-def');
                            customToggle.classList.add('tgl-on');
                            this.datos.d3acreditaVh = 1;
                            this.check = 3;
                        }
                        else if (datosTercero[0].d3acreditaVh == 0) {//si en base tiene 0 en sistema es 1
                            customToggle.classList.remove('tgl-def', 'tgl-on');
                            customToggle.classList.add('tgl-off');
                            this.datos.d3acreditaVh = 0;
                            this.check = 1;
                        }
                        //else if (typeof datosTercero[0].d3acreditaVh == "object") {//si en base tiene null en sistema es 2
                        else {
                            customToggle.classList.remove('tgl-on', 'tgl-off');
                            customToggle.classList.add('tgl-def');
                            this.datos.d3acreditaVh = null;
                            this.check = 2;
                        }

                    }
                }, 1000);





                this.valEli = true;
                this.showmontooficial = this.datos.d3montooficial != '' ? true : false;
                Reporte.obtenerTelefonosTercero(this, d3id).then(datostel => {
                    this.telefonos = []
                    let auxtelefonos = datostel;
                    for (let i in auxtelefonos) {
                        for (const [key, value] of Object.entries(auxtelefonos[i])) {
                            if (typeof value == "object") { auxtelefonos[i][key] = "" } else { auxtelefonos[i][key] = value.toString() }
                        }
                    }
                    this.telefonos = auxtelefonos;
                });



            }
            else {
                this.cancelar();
            }


        },
        nuevoAgregarTercero() {
            this.valEli = false;
            this.disabledSave = false;
            this.edit = true;
            this.vagregarTelefonos = true;
            this.activeTelefonosdet = true;
            this.agregarEditTelefonos = false;
            this.limpiarFormulario();

            this.classdisableanio = '';

            this.classdisabled = '';
            this.telefonos = [];

            this.valestdanios = true;
            this.valestlesiones = true;
            this.classdisableddanios = 'disable-action';
            this.classdisabledlesiones = 'disable-action';
            this.valaseguradora = true;
            this.classdisableddanios = "disable-action";

            this.valAlta = true;
            this.valEdit = false;

            setTimeout(() => {
                this.edit = false;
            }, 300);

        },
        cancelar() {
            this.classdisableanio = 'disable-action';

            this.valleshomVer = false;
            this.valdanosVer = false;
            this.valdanos = false;
            this.valleshom = false;
            this.valEli = false;
            this.disabledSave = false;
            this.vagregarTelefonos = false;
            this.activeTelefonosdet = false;
            this.agregarEditTelefonos = false;
            this.d3id = 0;
            this.limpiarFormulario();
            this.edit = true;
            this.classdisabled = 'disable-action';
            this.valEdit = false;
            this.valAlta = false;
            this.telefonos = [];
            this.classdisableanio = 'disable-action';
            this.valestdanios = true;
            this.valestlesiones = true;
            this.classdisableddanios = 'disable-action';
            this.classdisabledlesiones = 'disable-action';
            this.validation = {
                errorDelito: false,
                errorDelitoLH: false,
                errorDaniosOcupante: false,
                errorHomicidioFuga: false,
                errorLesiones: false,
                errorTipoT: false,
                errorEstadoT: false,
                errorCompania: false,
                errorCobertura: false,
                errorMarca: false,
                errorModelo: false,

                errorNombre: '',
                errorDomicilio: '',
                errorAnio: '',
                errorPlaca: '',
                errorColor: '',
                errorEstimadoDanios: '',
                errorEstimadoLesiones: '',
                errorPoliza: '',
                errorSiniestro: '',
                montoazul: '',
            }
            this.$refs.form.resetValidation();

        },
        limpiarFormulario() {
            this.d3id = 0;
            this.datos = {
                d3danios: false,
                d3lesiones: false,
                d3lesionesclave: null,
                d3homicidio: false,
                d3tipo: null,
                d3situacion: null,
                d3ebriedad: false,
                d3drogas: false,
                d3nombre: null,
                dedirec: null,
                d3email: null,
                mrclave: null,
                mdclave: null,
                d3anio: null,
                d3color: null,
                d3placa: null,
                d3montoest: null,
                montopendientedanios: false,
                aseclave: null,
                d3tipocob: null,
                d3poliza: null,
                d3montoestles: null,
                montopendientelesiones: false,
                d3montoazul: null,
                d3siniestro: null,
                d3descdanos: null,

                sttid: null,
                numtelf: null,
                numtelf2: null,

                clave: null,
                apiDT: null,

                valmontopendientedanios: false,
                valmontopendienteleshom: false,
                d3montooficial: null,
                d3sindatoanio: false,
            }

            this.phone = {
                number: null,
                valid: false,
                country: null
            };
            this.prefijo = null;
            this.pais = 'MX';
            this.validTelf = true;
            this.validaTipo = false;
            this.disabledsaveTelf = false;
            this.vguardaedita = true;
            this.datosTelefono = null;
            this.valaseguradora = true;
            this.classdisableddanios = "disable-action";
            this.valestdanios = true;
            this.classdisabledlesiones = "disable-action";
            this.valestlesiones = true;

        },
        eliminaTelf(item, index) {
            this.$swal({
                position: 'center',
                icon: 'warning',
                title: '¿Está seguro de eliminar el teléfono?',
                allowEscapeKey: false,
                allowOutsideClick: false,
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Eliminar',
                cancelButtonText: 'Cancelar',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.$swal({
                        position: 'center',
                        title: 'Eliminando teléfono ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                            this.$swal.showLoading();
                        }
                    });


                    await Reporte.eliminarTelefonoTercero(this, item);

                    setTimeout(async () => {
                        this.$swal.close();
                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Se eliminó el teléfono con éxito.',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        }).then((result) => {
                            if (result.isConfirmed) { }
                        })


                        Reporte.obtenerTelefonosTercero(this, item.d3id).then(datostel => {
                            this.telefonos = []
                            let auxtelefonos = datostel;
                            for (let i in auxtelefonos) {
                                for (const [key, value] of Object.entries(auxtelefonos[i])) {
                                    if (typeof value == "object") { auxtelefonos[i][key] = "" } else { auxtelefonos[i][key] = value.toString() }
                                }
                            }
                            this.telefonos = auxtelefonos;
                        });


                    }, 2000);
                }

            })

        },
        ocultartele(telefono, ban) {
            if (!ban) {
                let chars = 0; // Cantidad de caracters visibles
                return telefono.split('').slice(chars, -1).map(v => '*').join('');
            }
            else
                return telefono;
        },
        separarNumeroTelefono(cadena) {
            let caracter = '-';
            let pasos = 2;
            let cadenaConCaracteres = "";
            const longitudCadena = cadena.length;
            for (let i = 0; i < longitudCadena; i += pasos) {
                if (i + pasos < longitudCadena) {
                    cadenaConCaracteres += cadena.substring(i, i + pasos) + caracter;
                } else {
                    cadenaConCaracteres += cadena.substring(i, longitudCadena);
                }
            }
            return cadenaConCaracteres;
        },
        eliminarTercero() {

            this.$swal({
                position: 'center',
                icon: 'warning',
                title: '¿Está seguro de eliminar el Tercero?',
                allowEscapeKey: false,
                allowOutsideClick: false,
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Eliminar',
                cancelButtonText: 'Cancelar',
            }).then(async (result) => {

                if (result.isConfirmed) {
                    this.$swal({
                        position: 'center',
                        title: 'Eliminando Tercero ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                            this.$swal.showLoading();
                        }
                    });
                    this.$store.commit("changeAsegurado", 0);
                    await Reporte.eliminarTercero(this, this.d3id);
                    this.updateTable = false;
                    setTimeout(async () => {

                        this.$swal.close();
                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Se eliminaron correctamente los datos del Tercero.',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.$store.commit("changeAsegurado", 1);
                                this.cancelar();
                                this.$emit("reload", true);
                            }
                        })


                        this.updateTable = true;
                    }, 2000);



                }



            })

        },
        limpiarCheckDanios() {
            if (this.datos.d3montoest != '' && this.datos.d3montoest != null) {
                this.datos.montopendientedanios = false;
            }

        },
        limpiarCheckLesiones() {
            if (this.datos.d3montoestles != '' && this.datos.d3montoestles != null) {
                this.datos.montopendientelesiones = false;
            }
        },
        limpiarCheckanio() {
            if (this.datos.d3anio != '' && this.datos.d3anio != null) {
                this.datos.d3sindatoanio = false;
            }

        },
        limpiarDanios() {
            this.datos.d3montoest = null;
        },
        limpiarLesiones() {
            this.datos.d3montoestles = null;
        },
        limpiaranio() {
            this.validation.errorAnio = '';
            this.datos.d3anio = null;
        },
        uppercase(input) {
            if (input == "d3descdanos") {
                if (this.datos.d3descdanos != '' && this.datos.d3descdanos != null) {
                    this.datos.d3descdanos = this.datos.d3descdanos.toUpperCase();
                }
            }
        },
        rulesInputsEmail(value) {
            var resultRules = [];
            if (value == null || value == '') {
                return resultRules
            }
            if (/^([\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})(;[\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})*$/i.test(value)) return resultRules
            resultRules.push('Correo invalido');
            return resultRules
        },
        rulesInputs(min, max) {
            var resultRules = [];
            resultRules.push((v) => {
                if (v == null || v == '') {
                    return true;
                } else {
                    if (v.trim().length < min) {
                        return "Mínimo " + min + " Carácteres";
                    } else if (v.trim().length > max) {
                        return "Máximo " + max + " Carácteres";
                    } else return true;
                }
            });
            return resultRules;
        },
        rulesInputsRequired(min, max) {
            var resultRules = [];
            resultRules.push((v) => {
                if (v == null || v == '') {
                    return 'Campo requerido';
                } else {
                    if (v.trim().length < min) {
                        return "Mínimo " + min + " Carácteres";
                    } else if (v.trim().length > max) {
                        return "Máximo " + max + " Carácteres";
                    } else return true;
                }
            });
            return resultRules;
        },
        ruleNumbers: function ($event, value) {

            if (value == '') {
                if ($event.charCode >= 49 && $event.charCode <= 57) {
                    return true;
                }
                else {
                    $event.preventDefault();
                }
            }
            else {
                if (($event.charCode >= 48 && $event.charCode <= 57)) {
                    return true;
                }
                else {
                    $event.preventDefault();
                }

            }
        },
        ruleMoney: function ($event, value) {

            if (value == '') {
                if ($event.charCode >= 49 && $event.charCode <= 57) {
                    return true;
                }
                else {
                    $event.preventDefault();
                }
            }
            else {
                if (($event.charCode >= 48 && $event.charCode <= 57) || $event.charCode == 46) {
                    return true;
                }
                else {
                    $event.preventDefault();
                }

            }
        },
        formatearDanios(x) {

            if (x.terminoDan == 'Ya') {
                return `<button type="button" class="v-btn v-btn--bottom v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--x-small green" title="Concluido" style="height: 22px; width: 22px;"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-check-bold theme--dark" style="font-size: 16px;"></i></span></button>`;
            }
            else if (x.terminoDan == 'No') {
                return `<button type="button" class="v-btn v-btn--bottom v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--x-small red" title="Sin Concluir" style="height: 22px; width: 22px;"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-close theme--dark" style="font-size: 16px;"></i></span></button>`;
            }
            else if (x.terminoDan == 'NA') {
                return `<button type="button" class="v-btn v-btn--bottom v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--x-small grey" title="No Aplica" style="height: 22px; width: 22px;"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-minus theme--dark" style="font-size: 16px;"></i></span></button>`;
            }
            return ``;

        },
        formatearLesHom(x) {
            if (x.terminoLesHom == 'Ya') {
                return `<button type="button" class="v-btn v-btn--bottom v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--x-small green" title="Concluido" style="height: 22px; width: 22px;"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-check-bold theme--dark" style="font-size: 16px;"></i></span></button>`;
            }
            else if (x.terminoLesHom == 'No') {
                return `<button type="button" class="v-btn v-btn--bottom v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--x-small red" title="Sin Concluir" style="height: 22px; width: 22px;"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-close theme--dark" style="font-size: 16px;"></i></span></button>`;
            }
            else if (x.terminoLesHom == 'NA') {
                return `<button type="button" class="v-btn v-btn--bottom v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--x-small grey" title="No Aplica" style="height: 22px; width: 22px;"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-minus theme--dark" style="font-size: 16px;"></i></span></button>`;
            }
            return ``;
        },
        formatearNegociaciones(x) {
            if (x.valNegociacion == '1') {
                return `<button type="button" class="v-btn v-btn--bottom v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--x-small green" title="Concluido" style="height: 22px; width: 22px;"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-check-bold theme--dark" style="font-size: 16px;"></i></span></button>`;
            }
            else if (x.valNegociacion == '2') {
                return `<button type="button" class="v-btn v-btn--bottom v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--x-small red" title="Sin Concluir" style="height: 22px; width: 22px;"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-close theme--dark" style="font-size: 16px;"></i></span></button>`;
            }
            else if (x.valNegociacion == '3') {
                return `<button type="button" class="v-btn v-btn--bottom v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--x-small grey" title="No Aplica" style="height: 22px; width: 22px;"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-minus theme--dark" style="font-size: 16px;"></i></span></button>`;
            }
            return ``;
        },
        formatearEditar(x) {
            if (x.editar == 1) {
                return `<button type="button" data-action="0" data-params="${x}" class=" dt-formatterAction v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default primary"><span class="v-btn__content"><span style="color: white;">Editar</span></span></button>`;

            }
            return ``;
        },

        async LlamadaIVR(telefono) {
            console.log('telefono', telefono)
            let actor = await Contacto.ObtenerTipoActor(this, 'Tercero');

            Contacto.LlamadaIVRServ(this, telefono.stnumero, actor).then(datostel => {
                if (datostel !== null) {
                    window.location = 'tel:' + datostel;
                }
            })
        },

        async DatosCI() {

            let responseIVR = await Contacto.ObtenerCodigoIVR(this); //ObtenerIVR
            this.ivr = responseIVR[0].IVR;

            if (responseIVR[0].SINTIEMPO == 'SI') {

                this.LLamarSintiempo = true;

            }


            let diasConclu = await Contacto.ObtenerDiasConcluidosT(this);
            if (this.ivr != 0 && diasConclu < 30) {

                //Habilitar permiso IVR
                this.permisoIVR = true;
            }
            else if (this.LLamarSintiempo && this.ivr != 0) {

                this.permisoIVR = true;
            }

        },


    },

    async mounted() {

        if (!this.validatermino || this.validaConclusion) { //si no tiene la fecha de termino o el permiso 160  o ya esta cerrado el reporte
            this.disabledbutton = true;
        }
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '349').then(response => {
            if (response.data.length > 0) {
                this.permisoOfuscar = true;
            }
        });

        let datosreporte = await MetodosGenerales.obtenerSessionReporte('reporte');
        this.displayInputs = {
            nrreporte: datosreporte.nrreporte,
            svindice: datosreporte.svindice
        };

        Reporte.obtenerMarcas(this);
        Reporte.obtenerAseguradoras(this);
        Reporte.obtenerPermisoEliminar(this);

        //Revisar Permisos IVR
        await this.DatosCI();


    }
}

</script>


<style lang="scss">
.hoverTel:hover {
    background-color: lightskyblue;
    cursor: pointer;
}
</style>
<style>
.wrapper {
    width: 300px;
    height: 50%;
    display: flex;
    justify-content: center;
    padding: 20px 0;
}

#custom-toggle {
    -webkit-appearance: none;
    appearance: none;
    height: 25px;
    width: 60px;
    background-color: lightgrey;
    -webkit-border-radius: 25px;
    border-radius: 50px;
    padding: 0 2px;
    margin: 0;
    cursor: pointer;
}

#custom-toggle.tgl-def::-webkit-slider-thumb {
    background-color: orange;
}

#custom-toggle.tgl-on::-webkit-slider-thumb {
    background-color: green;
}

#custom-toggle.tgl-off::-webkit-slider-thumb {
    background-color: red;
}

#custom-toggle::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 24px;
    height: 24px;
    -webkit-border-radius: 25px;
    border-radius: 25px;
}

#custom-toggle:focus {
    outline: none;
}

.rangeActive {
    background-color: green;
}
</style>